import(/* webpackMode: "eager" */ "/vercel/path0/app/designs/page.tsx");
